<template>
    <ActivityWidget>
        <template name="Thumbnail"></template>
        <template name="CenterTextArea"></template>
        <template name="Icons"></template>
    </ActivityWidget>
</template>
